export var selectionTotal = function (cappedTotal, exactTotal, isCountCapped) {
    if (exactTotal !== undefined)
        return exactTotal;
    return isCountCapped ? undefined : cappedTotal;
};
